<div class="gather-credentials-container">
  <div class="description">
    Syncing your EDI file will automate receipt of new inventory from your wholesaler. Before we can start you’ll need the following:
  </div>
  <ul class="credentials-list">
    <li>Server URL of current EDI feed</li>
    <li>FTP username</li>
    <li>FTP password</li>
    <li>Your wholesaler name</li>
    <li>Your wholesaler account number</li>
  </ul>

  <div class="controls">
    <app-button customClasses="w-full"
                text="Continue"
                class="continue"
                (clicked)="nextStep.emit(WholesalerIntegrationStepsEnum.PendingConnection)"
    >
    </app-button>

    <app-button subStyle="transparent"
                customClasses="w-full"
                text="Cancel"
                class="cancel"
                (clicked)="cancel.emit()"
    >
    </app-button>
  </div>
</div>
